import React, { createContext, useContext, useState, useCallback } from "react";

const AlertContext = createContext();

let idCounter = 0;

export const AlertProvider = ({ children }) => {
  const [alerts, setAlerts] = useState([]);

  const showAlert = useCallback(
    ({ type = "info", message = "", duration = 3000 }) => {
      const id = idCounter++;
      setAlerts((prev) => [...prev, { id, type, message }]);
      setTimeout(() => {
        setAlerts((prev) => prev.filter((a) => a.id !== id));
      }, duration);
    },
    []
  );

  return (
    <AlertContext.Provider value={{ showAlert }}>
      {children}
      <div className="fixed top-5 right-5 flex flex-col items-end gap-3 z-[9999]">
        {alerts.map((alert) => (
          <div
            key={alert.id}
            className={`
              max-w-xs w-full px-4 py-3 rounded-lg shadow-lg text-white
              animate-slide-in-right transition-transform transform
              ${alert.type === "success" ? "bg-emerald-500" : ""}
              ${alert.type === "error" ? "bg-rose-500" : ""}
              ${alert.type === "warning" ? "bg-amber-500" : ""}
              ${alert.type === "info" ? "bg-slate-500" : ""}
            `}
          >
            {alert.message}
          </div>
        ))}
      </div>
    </AlertContext.Provider>
  );
};

export const useAlert = () => {
  return useContext(AlertContext);
};
